import type { ICustomerOrderExecutionRule } from '@talos/kyoko';

function hasThresholdValue(value: unknown): boolean {
  return value != null && value !== '';
}

export function hasNotionalThreshold(rule: Partial<ICustomerOrderExecutionRule>): boolean {
  return hasThresholdValue(rule.MinNotionalThreshold) || hasThresholdValue(rule.MaxNotionalThreshold);
}

export function hasTimeWindowPartial(rule: Partial<ICustomerOrderExecutionRule>): boolean {
  const hasStart = rule.StartTime != null && rule.StartTime !== '';
  const hasEnd = rule.EndTime != null && rule.EndTime !== '';
  return (hasStart && !hasEnd) || (!hasStart && hasEnd);
}

export function validatePriority(rule: Partial<ICustomerOrderExecutionRule>): string | undefined {
  // NumberInput keeps Priority as a string in form state; transformDrawerValueToNumber runs only on save.
  const raw = rule.Priority as unknown;
  if (raw == null || raw === '') {
    return 'Priority is required';
  }
  const priority = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(priority)) {
    return 'Priority is required';
  }
  if (priority < 0) {
    return 'Priority must be >= 0';
  }
  return undefined;
}

export function validateTimeWindow(rule: Partial<ICustomerOrderExecutionRule>): string | undefined {
  if (hasTimeWindowPartial(rule)) {
    return 'Start Time and End Time must both be set or both be empty';
  }
  return undefined;
}
